import React from 'react'
import { Link, useParams } from 'react-router-dom'
import { UserLayout } from 'components/layout/UserLayout'
import { FullPageHeader } from 'components/layout/FullPageLayout/Header/FullPageHeader'
import { useSprintPacket } from 'hooks/api/useSprintPackets'
import { PacketEditorBody } from './editor/PacketEditorBody'
import { usePacketFonts } from './usePacketFonts'

export function EditSprintPacket() {
  usePacketFonts()
  const { businessID, packetID } = useParams<{ businessID: string; packetID: string }>()
  const packetIDNum = Number(packetID)
  const { packet } = useSprintPacket(packetIDNum)

  const sprintCrumb = packet?.sprint?.name ?? 'Sprint'
  const breadcrumbs = [
    { title: 'Sprint Packets', route: `/${businessID}/sprint-packets` },
    { title: sprintCrumb },
    { title: 'Edit' },
  ]

  return (
    <UserLayout>
      <FullPageHeader breadcrumbs={breadcrumbs}>
        <div className="ml-auto pr-4">
          <Link
            to={`/${businessID}/sprint-packets/${packetID}/present`}
            className="inline-flex items-center gap-2 px-4 py-2 rounded-lg bg-purple-600 hover:bg-purple-700 text-white text-sm font-semibold transition-colors"
          >
            <i className="fa fa-play" />
            Present
          </Link>
        </div>
      </FullPageHeader>
      <PacketEditorBody businessID={Number(businessID)} packetID={packetIDNum} />
    </UserLayout>
  )
}
